var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:({ 'background-color': ("rgb(" + (_vm.spotColor.red) + ", " + (_vm.spotColor.green) + ", " + (_vm.spotColor.blue) + ")")})})}
var staticRenderFns = []

export { render, staticRenderFns }